[
  {
    "code": "AE-AZ",
    "name": "Abu Dhabi"
  },
  {
    "code": "AE-AJ",
    "name": "Ajman"
  },
  {
    "code": "AE-DU",
    "name": "Dubai"
  },
  {
    "code": "AE-FU",
    "name": "Fujairah"
  },
  {
    "code": "AE-RK",
    "name": "Ra's al-Khaimah"
  },
  {
    "code": "AE-SH",
    "name": "Sharjah"
  },
  {
    "code": "AE-UQ",
    "name": "Umm al-Qaiwain"
  }
]